import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import MetaTags from 'react-meta-tags';
import _ from 'lodash';

import { getBlogPosts, createBlogPost, deleteBlogPost, editBlogPost } from '../../Actions/BlogActions';
import { isAdmin } from '../../Helpers/user_helpers';
import { isContentRendered } from '../../Helpers/helpers';

import { addEvent } from '../../APIClient/events';

import BlogPostPreview from '../../Components/Blog/BlogPostPreview';
import ScrollToTop from '../../Components/General/ScrollToTop';

import './Blog.scss';

class Blog extends Component {
  static propTypes = {
    user: PropTypes.object.isRequired,
    blog: PropTypes.object.isRequired,
    getBlogPosts: PropTypes.func.isRequired,
    createBlogPost: PropTypes.func.isRequired,
    deleteBlogPost: PropTypes.func.isRequired,
    editBlogPost: PropTypes.func.isRequired
  };

  state = {
    waitingOnSSR: isContentRendered() // ensure admin specific elements wait on SSR to complete before loading to ensure hydration completes accurately
  };

  componentDidMount() {
    this.props.getBlogPosts();
    addEvent('Blog - View');
    this.state.waitingOnSSR && this.setState({ waitingOnSSR: false });
  }

  getVisiblePosts = () => {
    const { user, blog } = this.props;
    const allPosts = _.orderBy(_.get(blog, 'posts', []), [p => new Date(isAdmin(user) ? p.createdAt : p.publishedAt)], ['desc']);
    const publishedPosts = _.filter(allPosts, post => !!post.publishedAt);
    return isAdmin(user) ? allPosts : window.__IS_SNAP__ ? publishedPosts.slice(0, 10) : publishedPosts;
  };

  render() {
    const posts = this.getVisiblePosts();
    const canEdit = isAdmin(this.props.user) && !this.state.waitingOnSSR;
    const hasPosts = posts && posts.length;
    return (
      <div className='blog-outer-container'>
        <MetaTags>
          <title>Blog | ShopMy</title>
          <meta property='og:title' content='Blog | ShopMy' />
          <meta property='description' content='Taking a deeper dive into the products used by industry leaders.' />
          <meta property='og:description' content='Taking a deeper dive into the products used by industry leaders.' />
        </MetaTags>
        <ScrollToTop from={['/home']} />
        {canEdit && (
          <div className='admin-top-row'>
            <div onClick={this.props.createBlogPost} className='create-new-post-btn'>
              CREATE NEW POST
            </div>
          </div>
        )}
        <div className={classnames('blog-posts skeleton', { loaded: hasPosts })}>
          <div className={classnames('el', { 'loaded-el': hasPosts })}>
            {_.map(
              posts,
              post =>
                post && (
                  <BlogPostPreview
                    key={post.id}
                    post={post}
                    canEdit={canEdit}
                    deleteBlogPost={this.props.deleteBlogPost}
                    editBlogPost={this.props.editBlogPost}
                    skinny
                  />
                )
            )}
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => {
  const { user, blog } = state;
  return { user, blog };
};

export default connect(mapStateToProps, {
  getBlogPosts,
  createBlogPost,
  deleteBlogPost,
  editBlogPost
})(Blog);
